<div class="main-radio-button--menu">
  <div class="label-container">
    <sl-typography
      [text]="label"
      variant="label"
      color="var(--color-neutral-90)"
    ></sl-typography>
    @if(required){
    <sl-typography
      text="*"
      variant="label"
      color="var(--color-red-60)"
    ></sl-typography>
    }
  </div>
  <div class="menu-buttons">
    @for(option of options;let idx = $index ; track option.name){
    <div class="input">
      <label [ngClass]="{ 'label-disabled': disabled }">
        <input
          type="radio"
          name="light"
          [id]="'option-' + option.name"
          [value]="option.value"
          [formControl]="control"
          (click)="onClickRadioButton(option.value)"
        />
        <span class="design" [ngClass]="{ disabled: disabled }"></span>
        <sl-typography
          variant="body-10"
          weight="regular"
          [text]="option.name"
          [color]="
            disabled ? 'var(--color-neutral-40)' : 'var(--color-neutral-90)'
          "
        ></sl-typography>
      </label>
    </div>
    }
  </div>
</div>
